import { baseSeriesMark } from "../base/constant";

export const sunburstSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    sunburst: {
        name: "sunburst",
        type: "arc"
    }
});
//# sourceMappingURL=constant.js.map
